import { Icon } from "@fluentui/react";
import { useEffect, useState } from "react";
import PingUtil from "../../Utils/PingUtil";
import "./VideoFrame.scss";
import ApiService from "../../Services/ApiService";
import { ISentinel } from "../../Models/ISentinel";
import { IAPIResponse } from "../../Services/AjaxService";
import { ISensorReading } from "../ConfigureCard/ConfigureCard";
import { GetProcessParam } from "../../Utils/ProcessParams";
import { useSelector } from "react-redux";
import { GlobalState } from "../../Redux/RootReducer";
import { JSONPrint } from "../../Utils/Generic";
import { AppConfig, getVideoRelayUrl, getVideoSdkUrlWithCamera } from "../../Config";

export interface IVideoFrameProps {
  sentinel: ISentinel;
  index: number;
  height: string;
  width: string;
  disableCamera?: boolean;
}

export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const VideoFrame = (props: IVideoFrameProps) => {
  const [disableCamera, setDisableCamera] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (props.disableCamera !== undefined) {
      setDisableCamera(props.disableCamera);
    }
  }, [props.disableCamera]);

  useEffect(() => {
    // Listener per il messaggio IFRAME_READY dall'iframe
    const handleIframeReady = (event: MessageEvent) => {
      if (event.data && event.data.type === "IFRAME_READY") {
        console.log("✅ VideoFrame: Ricevuto IFRAME_READY, nascondo loader");
        setIsLoading(false);
      }
    };

    window.addEventListener("message", handleIframeReady);

    return () => {
      window.removeEventListener("message", handleIframeReady);
    };
  }, []);

  // In cloud (relay) il browser conosce solo l'id della sentinella; in locale resta il player
  // Dahua, che si collega direttamente alla telecamera con i suoi parametri.
  const urlTarget: string = AppConfig.videoSdk.relay
    ? getVideoRelayUrl(props.sentinel.id)
    : getVideoSdkUrlWithCamera(props.sentinel.cameraUrl.split(";").map((x) => x.trim()));

  return (
    <div
      className="video-frame-container-video-frame-wrap"
      style={{ width: props.width, height: props.height }}
    >
      <div className="video-frame-container">
        {disableCamera && (
          <div
            className="monitoring-card-no-video-icon"
            style={{ width: props.width, height: props.height }}
          >
            <div className="video-frame-container-no-video-inner">
              <Icon iconName="videoOff" />
            </div>
          </div>
        )}
        {!disableCamera && (
          <>
            {isLoading && (
              <div className="video-frame-loader-overlay">
                <div className="video-frame-loader-content">
                  <div className="video-frame-spinner"></div>
                  <div className="video-frame-cam-label">
                    Caricamento live...
                  </div>
                </div>
              </div>
            )}
            <iframe
              style={{ border: "none" }}
              width={props.width}
              height={props.height}
              src={urlTarget}
            ></iframe>
          </>
        )}
      </div>
    </div>
  );
};

export default VideoFrame;
